import React from 'react';

import phoneHeader from './images/legentibus_header.png';
import phoneContent from './images/legentibus_content.jpg';
import phoneFrame from './images/iphone_frame.png';

import {
    Box,
    Typography,
    Button,
} from "@mui/material";

import PhoneAssignment from "./PhoneAssignment";

const AssignmentSummary = ({
    editMode,
    assignment,
    taskType,
    numWords,
    numMinutes,
    book,
    selectedChapters,
    instructions,
    dueDate,
    errorMessage,
    handleEdit,
    handleSave,
    handleDelete,
    handleCancel
}) => {

    const smallWindow = window.innerHeight < 800;
    const height = Math.max(350, Math.min(window.innerHeight - (smallWindow ? 350 : 370), 580)) + 'px';
    const marginTop = (smallWindow ? 20 : 40) + 'px';
    const marginBottom = (smallWindow ? 30 : 40) + 'px';

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>Assignment Summary</Typography>
            </Box>

            <div className="phone-container" style={{ height, marginTop, marginBottom }}>
                <div className="phone-inner-container" style={{ height }}>
                    <img className="phone-header" src={phoneHeader} alt=""/>
                    <div className="phone-content-container">
                        <PhoneAssignment
                            taskType={taskType}
                            dueDate={dueDate}
                            selectedChapters={selectedChapters}
                            numWords={numWords}
                            numMinutes={numMinutes}
                            book={book}
                            instructions={instructions}
                        />
                        <img className="phone-content" src={phoneContent} alt=""/>
                    </div>
                    <img className="phone-frame" src={phoneFrame} alt="iPhone mockup"/>
                </div>
            </div>

            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

            { assignment ?
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, mb: 2 }}>
                    <Box sx={{ mr: 5 }}>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleDelete}
                        >
                            Delete
                        </Button>
                    </Box>
                    <Box>
                        { editMode ?
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{ mr: 2 }}
                                onClick={handleSave}
                            >
                                Save
                            </Button>
                        :
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{ mr: 2 }}
                                onClick={handleEdit}
                            >
                                Edit
                            </Button>
                        }
                        <Button
                            variant="outlined"
                            color="primary"
                            sx={{ mr: 2 }}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            :
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 0, mb: 2 }}
                    onClick={handleSave}
                >
                    Finish
                </Button>
            }
        </Box>
    );
};

export default AssignmentSummary;
